import React, { FC } from 'react';
import Button, { ButtonProps } from 'components/Button';
import _ from '@dh-fe/translate';
import routes from 'configs/routes';

export interface SignUpButtonComponent {
    children?: string;
    className?: string;
    type?: ButtonProps['type'];
    size?: ButtonProps['size'];
    target?: ButtonProps['target'];
    rel?: ButtonProps['rel'];
}

const SignUpButton: FC<SignUpButtonComponent> = ({
    className,
    type = 'primary',
    size = 'm',
    children = _`Join Us!`,
    target,
    rel,
}) => {
    const { search } = window.location;
    const params = new URLSearchParams(search);

    // remove the unnecessary 'forceShow' parameter
    params.delete('forceShow');

    return (
        <Button
            dataTestId="signup-button"
            size={size}
            type={type}
            href={routes.signUpUrl(params.toString())}
            className={className}
            target={target}
            rel={rel}
        >
            {children}
        </Button>
    );
};

export default React.memo(SignUpButton);
